import { render } from "./MobileNavComp.vue?vue&type=template&id=164628da&scoped=true&ts=true"
import script from "./MobileNavComp.vue?vue&type=script&lang=ts"
export * from "./MobileNavComp.vue?vue&type=script&lang=ts"

import "./MobileNavComp.vue?vue&type=style&index=0&id=164628da&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164628da"]])

export default __exports__